import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { filter, map, startWith } from 'rxjs/operators';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { ThemeService } from '../../@fury/services/theme.service';
import { checkRouterChildsData } from '../../@fury/utils/check-router-childs-data';
import { QuickPanelService } from './quickpanel/quick-panel.service';
import { LoadingIndicatorComponent } from 'src/@fury/shared/loading-indicator/loading-indicator.component';
import { BackdropDirective } from 'src/@fury/shared/backdrop/backdrop.directive';
import { SidebarDirective } from '../../@fury/shared/sidebar/sidebar.directive';
import { ConfigPanelComponent } from './config-panel/config-panel.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { QuickpanelComponent } from './quickpanel/quickpanel.component';
import { SteelAlertsPanelComponent } from './quickpanel/steel-alerts-panel/steel-alerts-panel.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { NavigationComponent } from './navigation/navigation.component';
import { SidenavService } from './sidenav/sidenav.service';
import { SteelHeaderComponent } from './steel/steel-header/steel-header.component';
import { SteelNavComponent } from './steel/steel-nav/steel-nav.component';
import { SteelAlertBannerComponent } from './steel/steel-alert-banner/steel-alert-banner.component';
import { AppThemeService } from 'src/app/main/shared/services/app-theme.service';

@Component({
  selector: 'fury-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  imports: [
    CommonModule,
    RouterModule,
    FlexLayoutModule,
    MatSidenavModule,
    SidebarDirective,
    LoadingIndicatorComponent,
    BackdropDirective,
    ConfigPanelComponent,
    SidenavComponent,
    QuickpanelComponent,
    SteelAlertsPanelComponent,
    ToolbarComponent,
    NavigationComponent,
    SteelHeaderComponent,
    SteelNavComponent,
    SteelAlertBannerComponent,
  ],
})
export class LayoutComponent implements OnInit, OnDestroy {
  @ViewChild('configPanel', { static: true }) configPanel: SidebarDirective;

  sidenavOpen$ = this.sidenavService.open$;
  sidenavMode$ = this.sidenavService.mode$;
  sidenavCollapsed$ = this.sidenavService.collapsed$;
  sidenavExpanded$ = this.sidenavService.expanded$;
  quickPanelOpen$ = this.quickPanelService.open$;
  quickPanelOpen: boolean;

  sideNavigation$ = this.themeService.config$.pipe(map((config) => config.navigation === 'side'));
  topNavigation$ = this.themeService.config$.pipe(map((config) => config.navigation === 'top'));
  toolbarVisible$ = this.themeService.config$.pipe(map((config) => config.toolbarVisible));
  toolbarPosition$ = this.themeService.config$.pipe(map((config) => config.toolbarPosition));

  scrollDisabled$ = this.router.events.pipe(
    filter<NavigationEnd>((event) => event instanceof NavigationEnd),
    startWith(null),
    map(() =>
      checkRouterChildsData(this.router.routerState.root.snapshot, (data) => data.scrollDisabled)
    )
  );

  constructor(
    private sidenavService: SidenavService,
    private quickPanelService: QuickPanelService,
    private themeService: ThemeService,
    private route: ActivatedRoute,
    private router: Router,
    public appTheme: AppThemeService
  ) {
    this.quickPanelOpen$.subscribe((val) => {
      this.quickPanelOpen = val;
    });
  }

  ngOnInit() {}

  openQuickPanel() {
    this.quickPanelOpen = true;
  }

  openConfigPanel() {
    this.configPanel.open();
  }

  closeSidenav() {
    this.sidenavService.close();
  }

  openSidenav() {
    this.sidenavService.open();
  }

  ngOnDestroy(): void {}
}
